<template>
  <div class="cmp cmp-student-card-1">
    <div class="card-top">
      <img class="student-photo" :src="userAvatarDict[data.headPhoto || '00']">
      <div class="student-name">{{data.studentName}}</div>
      <div class="text-center">
        <el-tag type="primary" effect="plain" @click="showCommentModal">
          <i class="fa fa-commenting"></i>{{data.commentNum || 0}}
        </el-tag>
        <el-tag type="primary" effect="plain" style="border:none">
          <i class="fa fa-heart"></i>{{data.flowerNum || 0}}
        </el-tag>
      </div>
    </div>
    <div class="card-bottom">
      <x-star-bar type="warning" :size="24" fill :index="data.starRating || 0" :disabled="userInfo.type==='STUDENT'"
        @click="worksEvaluate"
      ></x-star-bar>
    </div>
    <x-modal v-model="visible" :height="560" :showFooter="userInfo.type==='STUDENT'">
      <div slot="header">作品评论</div>
      <div class="modal-body-inner">
        <div class="comments-list">
          <div class="comments-item" v-for="(v,i) in workComments" :key="i">
            <el-row type="flex" align="center">
              <el-col :span="18" class="speaker">
                <img class="speaker-photo" :src="userAvatarDict[v.headPhoto || '00']">
                <span class="speaker-name">{{v.studentName}}</span>
                <span class="speaker-time">{{v.createTime}}</span>
              </el-col>
              <el-col :span="6" class="text-right">
                <x-star-bar type="danger" :size="16" fill :index="v.flowerNum || 0" disabled></x-star-bar>
              </el-col>
            </el-row>
            <el-row type="flex" align="center" class="message">
              <el-col :span="22" class="message-content">{{v.content}}</el-col>
              <el-col :span="2" class="text-right">
                <i v-if="userInfo.type==='TEACHER' || v.studentId===userInfo.studentId"
                  class="el-icon-delete" @click="deleteComment(v)"
                ></i>
              </el-col>
            </el-row>
          </div>
          <div v-if="workComments.length===0" class="nodata nodata-rates"></div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div slot="footer">
        <el-input type="textarea" :rows="4" :maxlength="100" v-model="comment" placeholder="快加入讨论吧"></el-input>
        <el-row type="flex" align="center">
          <el-col :span="18" class="text-left">
            <template v-if="!flowerFlag">
              给TA送花：<x-star-bar type="danger" :size="16" fill :index="flowerNum" @click="clickStarHandler"></x-star-bar>
            </template>
          </el-col>
          <el-col :span="6" class="text-right">
            <el-button type="primary" size="small" @click="submitComment">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </x-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import publicUrl from '@/assets/js/interface'

export default {
  name: 'cmp-student-card-1',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      workComments: [],
      comment: '',
      flowerFlag: false,
      flowerNum: 0,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      loadingCount: 0
    }
  },
  computed: {
    ...mapState(['userInfo', 'userAvatarDict'])
  },
  methods: {
    showCommentModal () {
      this.visible = true
      this.getWorkComments()
    },
    getWorkComments () {
      this.loadingCount++
      this.workComments = []
      this.$ajax.get(publicUrl.worksReview, {
        params: {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          workId: this.data.id,
        }
      }).then(res => {
        if (res.data.code === 0) {
          let _data = res.data.data || {}
          this.workComments = (_data.result || [])
          this.total = _data.totalCount || 0
          this.flowerFlag = _data.flowerFlag || false
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getWorkComments()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getWorkComments()
    },
    worksEvaluate (index) {
      this.loadingCount++
      let params = {
        starNum: index,
        workId: this.data.id,
      }
      this.$ajaxJson.post(publicUrl.worksEvaluate, params).then(res => {
        if (res.data.code === 0) {
          // this.$emit('update', params)
          this.$message.success('保存成功' || res.data.message)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    },
    clickStarHandler (index) {
      this.flowerNum = index
    },
    submitComment () {
      if (!this.comment) {
        this.$message.warning('请输入评论内容')
        return
      }
      this.loadingCount++
      this.$ajaxJson.post(publicUrl.submitWorksReview, {
        content: this.comment,
        flowerNum: this.flowerNum || 0,
        id: this.data.id,
      }).then(res => {
        if (res.data.code === 0) {
          this.$message.success(res.data.message || '评论发表成功')
          this.getWorkComments()
          this.comment = ''
          this.flowerNum = 0
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    },
    deleteComment (item) {
      this.loadingCount++
      this.$ajaxJson.post(publicUrl.deleteWorksReview, {
        id: item.id,
      }).then(res => {
        if (res.data.code === 0) {
          this.$message.success(res.data.message || '评论删除成功')
          this.getWorkComments()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cmp-student-card-1 {
  width: 276px;
  margin: 10px auto;
  border-radius: 6px;
  box-shadow: 0px 4px 8px 0px rgba(134, 144, 167, 0.3);
  overflow: hidden;
  .card-top {
    height: 253px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .student-photo {
      display: block;
      width: 126px;
      height: 126px;
      border: 1px solid #CED2DA;
      border-radius: 50%;
    }
    .student-name {
      height: 40px;
      font-size: 20px;
      color: #464C5B;
      line-height: 40px;
    }
    .el-tag {
      margin: 0 10px;
      &:first-child {cursor: pointer;}
      i {margin-right: .5em;}
    }
  }
  .card-bottom {
    height: 42px;
    background: #ECECEC;
    .x-star-bar {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
  .modal-body-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    .comments-list {
      height: 0;
      margin-bottom: 10px;
      flex-grow: 1;
      overflow: hidden auto;
      .comments-item {
        .speaker {
          line-height: 36px;
          margin-bottom: 10px;
          .speaker-photo {
            width: 28px;
            height: 28px;
            margin-right: 10px;
            border: 1px solid #CED2DA;
            border-radius: 50%;
            vertical-align: middle;
          }
          .speaker-name, .speaker-time {margin-right: 15px;}
          .speaker-name {font-size: 20px; color: #657180;}
          .speaker-time {font-size: 16px; color: #9EA7B4;}
        }
        .message {
          padding: 6px;
          margin-left: 40px;
          line-height: 24px;
          border-radius: 6px;
          background-color: #f5f5f5;
          .el-icon-delete {
            padding: 5px;
            cursor: pointer;
          }
        }
      }
    }
    .el-pagination {
      text-align: center;
    }
  }
  .x-modal /deep/ .x-modal__footer {
    .el-row {
      line-height: 32px;
      margin-top: 10px;
    }
  }
}
.message-content {
  word-break: break-all;
  word-break: break-word;
}
</style>
